import { Button, Input } from '@artosera/ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useArtiste, useArtistes } from '../../api/artistes.js';
import { useDebounce } from '../oeuvres/useDebounce.js';
import { Field } from '../Field.js';
import styles from './Profils.module.css';

export function NomArtiste({ galerieSlug, id }: { galerieSlug: string; id: string }) {
  const { t } = useTranslation('regie');
  const artiste = useArtiste(galerieSlug, id);
  return <>{artiste.data?.nom ?? t('profils.artisteInconnu')}</>;
}

export function SelectionArtistes({
  galerieSlug,
  id,
  label,
  valeur,
  onChange,
}: {
  galerieSlug: string;
  id: string;
  label: string;
  valeur: string[];
  onChange: (ids: string[]) => void;
}) {
  const { t } = useTranslation('regie');
  const [recherche, setRecherche] = useState('');
  const q = useDebounce(recherche, 300);
  const artistes = useArtistes(galerieSlug, { q, tri: 'nom', inclureArchives: true });
  return (
    <fieldset className={styles.formulaire}>
      <legend>{label}</legend>
      <ul>
        {valeur.map((artisteId) => (
          <li key={artisteId}>
            <NomArtiste galerieSlug={galerieSlug} id={artisteId} />{' '}
            <Button
              size="sm"
              variant="ghost"
              onClick={() => onChange(valeur.filter((choisi) => choisi !== artisteId))}
            >
              {t('profils.retirer')}
            </Button>
          </li>
        ))}
      </ul>
      <Field htmlFor={id} label={t('profils.rechercherArtiste')}>
        <Input
          id={id}
          type="search"
          value={recherche}
          onChange={(event) => setRecherche(event.target.value)}
        />
      </Field>
      {artistes.isLoading && <p role="status">{t('commun:chargement')}</p>}
      {artistes.isError && <p role="alert">{t('commun:erreurReseau')}</p>}
      <select
        className={styles.selection}
        aria-label={label}
        value=""
        onChange={(event) => {
          if (event.target.value) onChange([...valeur, event.target.value]);
        }}
      >
        <option value="">{t('profils.choisirArtiste')}</option>
        {artistes.data?.artistes
          .filter((artiste) => !valeur.includes(artiste.id))
          .map((artiste) => (
            <option key={artiste.id} value={artiste.id}>
              {artiste.nom}
            </option>
          ))}
      </select>
    </fieldset>
  );
}
